export default __webpack_public_path__ + "static/media/ISC-PropEx-PropertyScreening.9633e087.png";